import React, { useState } from "react";
import s from "./style.module.scss";
import Input from "shared/ui/Input";
import Button from "shared/ui/Button";
import { LoginFormProps } from "./types";
import { useAppDispatch } from "shared/redux/hooks";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { handleLogin } from "../lib/handleLogin";

const LoginForm: React.FC<LoginFormProps> = ({ phone }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [cookie, setCookie] = useCookies(["auth_key", "user_id"]);

  const [code, setCode] = useState("");

  const [dataSending, setDataSending] = useState(false);

  const buttonDisabled = dataSending || code.trim() === "";

  return (
    <form className={s.form}>
      <p>На номер телефона был отправлен код</p>
      <Input
        className={s.input}
        value={code}
        setValue={setCode}
        mask={String}
        placeholder="Код"
      />

      <Button
        className={s.button}
        onClick={() =>
          handleLogin({
            code,
            dispatch,
            navigate,
            phone,
            setCookie,
            setDataSending,
          })
        }
        disabled={buttonDisabled}
      >
        Войти
      </Button>
    </form>
  );
};

export default LoginForm;
